import * as angular from 'angular';
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import EditPlantName, {openEditPlant} from "./editPlant.controller";
import {States} from "../../shared/config/constant.module";
import template from './plants.tpl.html';
import PlantServiceName, {PlantService} from "../../services/plant/plant.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import { AuthDataService } from '../../services/auth/authData.service';

let requires = [EditPlantName, PlantServiceName, LoaderServiceName];

interface PlantsController {
  plants: apsViewModels.PlantInfo[];
  hasPlants(): boolean;
  editPlant(plant: apsViewModels.PlantInfo): void;
}

export default angular.module('aps.controller.plants', requires)
  .config(plantsConfig)
  .controller('PlantsCtrl', plantsCtrl)
  .name;

function plantsConfig($stateProvider: angular.ui.IStateProvider) {
  $stateProvider.state({
    name: States.PLANTS,
    url: '/admin/plants',
    controller: 'PlantsCtrl as plantsCtrl',
    template: template,
    data: {
      pageTitle: 'Plants',
      authorizeAdmin: true
    }
  });
}

function plantsCtrl(
  plantService: PlantService,
  loaderService: LoaderService,
  $modal: mm.foundation.modal,
  authDataService: AuthDataService
) {
  let vm = this as PlantsController;

  vm.plants = [];

  vm.hasPlants = function(){
    return vm.plants && vm.plants.length > 0;
  };

  vm.editPlant = function(plant: apsViewModels.PlantInfo) {
    if (authDataService.isAPSIOAdmin) {
      openEditPlant({
        plant: plant,
        plants: vm.plants
      }, $modal);
    }
  };

  loaderService.loadingPromise(
    plantService.getPlants().then(
      function (plants) {
        vm.plants = plants;
  }));

  return vm;
}



// WEBPACK FOOTER //
// ./src/app/controllers/plants/plants.controller.ts